import { CollapsibleProps, RolesPermissionsProps, SharedModalProps } from '../../types';
import SideSheet from '../../components/NewSideSheet';
import useRolePermissions from '../../hooks/useRolePermissions';
import { useState } from 'react';
import { Loader } from '@piggytechng/component-library';

const Collapsible = ({ title, children }: CollapsibleProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="collapsible">
      <div className="collapsible-header" onClick={() => setOpen(!open)}>
        <span>{title}</span>
        <span className={`arrow ${open ? 'open' : ''}`}>&#9662;</span>
      </div>
      {open && <div className="collapsible-body">{children}</div>}
    </div>
  );
};

const RolesPermissions = ({ roles }: RolesPermissionsProps) => {
  return (
    <div className="roles-container">
      {roles.map((role) => (
        <Collapsible key={role.roleId} title={role.roleName}>
          <div className="sections-container">
            {Object.entries(role.permissions).map(([section, actions]) => (
              <Collapsible key={section} title={section}>
                <ul className="actions-list">
                  {actions.map((action, index) => (
                    <li key={index} className="action-item">
                      Can {action}
                    </li>
                  ))}
                </ul>
              </Collapsible>
            ))}
          </div>
        </Collapsible>
      ))}
    </div>
  );
};

const ViewRolesMatrix = ({ onClose = () => {}, show }: SharedModalProps) => {
  const { rolesAndPermissions, isLoadingRolesAndPermissions } = useRolePermissions({});

  const close = () => {
    onClose();
  };

  return (
    <SideSheet onClose={close} active={show} title="Roles & Permissions">
      <div>
        {isLoadingRolesAndPermissions ? (
          <div>
            <Loader color="#0F60D6" maxWidth="50px" />
          </div>
        ) : (
          <RolesPermissions roles={rolesAndPermissions?.data} />
        )}
      </div>
    </SideSheet>
  );
};

export default ViewRolesMatrix;
